import Toast from "@base/Toast/Toast"

export default Toast;
